import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ListRequestParams } from 'modules/domain/types'
import ASelectFilter from 'views/components/Analytics/ASelectFilter'
import { SamplesProgressStatuses, SampleStatus } from '../types'

interface Props {
  listRequestParams: ListRequestParams
  updateFilterState: any
}

export const SampleStatusFilter: FC<Props> = ({ listRequestParams, updateFilterState }) => {
  const { t } = useTranslation('samples')

  const options = useMemo(() => {
    const sampleRequestStatuses = Object.values(SamplesProgressStatuses)
      .filter((item) => ![SamplesProgressStatuses.CANCELED, SamplesProgressStatuses.COMPLETED].includes(item))
      .map((item) => ({
        value: item as string,
        label: t(`sampleRequestStatusesForTags.${item}`),
      }))
    return [
      { value: SampleStatus.published, label: t('sampleStatus.published') },
      { value: SampleStatus.in_progress, label: t('sampleStatus.in_progress') },
      ...sampleRequestStatuses,
      { value: SampleStatus.archived, label: t('sampleStatus.archived') },
      { value: SampleStatus.canceled, label: t('sampleStatus.canceled') },
    ]
  }, [t])

  return (
    <ASelectFilter
      onChange={(united_status) => updateFilterState({ united_status })}
      value={listRequestParams.filter.united_status || []}
      placeholder={t('common:status')}
      options={options}
      showSearch={false}
      id="statusFilter"
      mode="multiple"
    />
  )
}
